import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Parent/Home";
import HelpSupport from "../../pages/Parent/HelpSupport";
import StudentProfiles from "../../pages/Parent/StudentProfiles";
import Feedback from "../../pages/Parent/Feedback";
import AtHomeSupportPage from "../../pages/AtHomeSupportPage";
import ProgressAndPride from "../../pages/Parent/ProgressAndPride";
import ParentAction from "../../pages/Parent/ParentAction";
import StudentGoalsComingSoon from "../StudentGoalsComingSoon";
import ViewData from "../../pages/Parent/ViewData";
import ParentConnect from "../../pages/Parent/ParentConnect";
import ParentCommunicationHub from "../../pages/Parent/ParentCommunicationHub";
import ParentCalendarEvents from "../../pages/Parent/ParentCalendarEvents";
import MyAssignments from "../../pages/LearningTasks/MyAssignments";
import RightsRequests from "../../pages/Parent/RightsRequests";

const ParentDashboard = () => (
  <Routes>
    <Route path="home" element={<Home />} />
    <Route path="grading" element={<StudentProfiles />} />
    <Route path="help-support" element={<HelpSupport />} />
    <Route path="help-support/tutorials" element={<HelpSupport focus="tutorials" />} />
    <Route path="surveys" element={<HelpSupport focus="surveys" />} />
    <Route path="student-profiles" element={<StudentProfiles />} />
    <Route path="data-points-report" element={<ViewData />} />
    <Route path="action" element={<ParentAction />} />
    <Route path="action/assignments" element={<MyAssignments audience="family" />} />
    <Route path="action/goals" element={<StudentGoalsComingSoon />} />
    <Route path="action/support" element={<ParentAction />} />
    <Route path="connect" element={<ParentConnect />} />
    <Route path="connect/messages" element={<ParentConnect />} />
    <Route path="connect/communication-hub" element={<ParentCommunicationHub />} />
    <Route path="connect/calendar-events" element={<ParentCalendarEvents />} />
    <Route path="requests" element={<RightsRequests />} />
    <Route path="progress-pride" element={<Navigate to="home" />} />
    <Route path="feedback" element={<Feedback />} />
    <Route path="student-progress/:studentId" element={<ProgressAndPride />} />
    <Route path="student-progress/:studentId/:classId" element={<ProgressAndPride />} />
    <Route path="at-home-support" element={<AtHomeSupportPage />} />
    <Route path="*" element={<Navigate to="home" />} />
  </Routes>
);

export default ParentDashboard;
